import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/sentraleOppgaver',
    name: 'SentraleOppgaver',
    component: () => import('./views/SentraleOppgaver.vue')
  }
]

export default routes
